/*
    Create By Qian.qianchen 2018-12-27
*/
'use strict';
angular.module("modifyNameModule", [])
    .controller("modifyNameCtrl", ['$scope', "$modalInstance", '$validation', 'transmission', function($scope, $modalInstance, $validation, transmission) {
        initData();
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        $scope.confirm = function() {
            $validation.validate($scope.typingForm).success(function() {
                transmission.callback($scope.content);
                $modalInstance.dismiss();
            });
        };

        function initData() {
            $scope.content = transmission.content;
        }
    }]);